import apiService from '../../apiService'
import Notification from '../../notification'

const STORAGE_KEY = 'impersonationClientLogin'

export default {
  namespaced: true,
  state: {
    login: null,
    member: null,
    active: false, // сотрудник имеет доступ к impersonation (есть member)
    clients: [],
    selectedClientLogin: null, // выбранный клиент (восстанавливается из localStorage)
    search: '',
    loading: false
  },
  mutations: {
    /**
     * Сохраняет текущего сотрудника; активность режима = наличие member.
     */
    setMe (state, { member, login }) {
      state.login = login
      state.member = member
      state.active = !!member
    },
    setClients (state, clients) {
      state.clients = clients
    },
    setSelectedClientLogin (state, login) {
      state.selectedClientLogin = login
    },
    setSearch (state, value) {
      state.search = value
    },
    setLoading (state, value) {
      state.loading = value
    }
  },
  actions: {
    /**
     * Загружает текущего сотрудника (/impersonation/me) и проставляет признак активности режима.
     */
    fetchMe ({ commit }) {
      return apiService.getImpersonationMe()
        .then(response => {
          const data = response.data || {}
          commit('setMe', {
            member: data.member
              ? { id: data.member.id, name: data.member.name, email: data.member.email }
              : null,
            login: data.login
          })
        })
        .catch(() => {
          commit('setMe', { member: null, login: null })
        })
    },
    /**
     * Загружает доступных клиентов (/impersonation/clients) и восстанавливает выбранного из localStorage
     * (иначе берёт первого), синхронизируя выбор в state и localStorage.
     */
    fetchClients ({ commit, state }) {
      commit('setLoading', true)

      return apiService.getImpersonationClients()
        .then(response => {
          const clients = Array.isArray(response.data) ? response.data : []
          commit('setClients', clients)

          if (!clients.length) {
            commit('setSelectedClientLogin', null)
            localStorage.removeItem(STORAGE_KEY)
            return
          }

          const stored = localStorage.getItem(STORAGE_KEY)
          const restored = stored && clients.some(client => client.login === stored) ? stored : null
          const login = restored !== null ? restored : clients[0].login

          if (state.selectedClientLogin !== login) {
            commit('setSelectedClientLogin', login)
          }
          localStorage.setItem(STORAGE_KEY, String(login))
        })
        .catch(() => {
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список клиентов.'
          })
        })
        .finally(() => {
          commit('setLoading', false)
        })
    },
    /**
     * Сохраняет выбранного клиента в localStorage и применяет выбор: переходит по redirectTo либо
     * перезагружает страницу. Payload — логин (строка) или объект { login, redirectTo }.
     */
    selectClient (_, payload) {
      const clientLogin = typeof payload === 'object' && payload !== null ? payload.login : payload
      const redirectTo = typeof payload === 'object' && payload !== null && payload.redirectTo ? payload.redirectTo : null

      localStorage.setItem(STORAGE_KEY, String(clientLogin))
      if (redirectTo) {
        window.location = redirectTo
      } else {
        window.location.reload()
      }
    },
    setSearch ({ commit }, value) {
      commit('setSearch', value)
    }
  },
  getters: {
    /**
     * Объект выбранного клиента из списка или null.
     */
    selectedClient: (state) => state.clients.find(client => client.login === state.selectedClientLogin) || null,
    /**
     * Клиенты, отфильтрованные по строке поиска (по имени, логину, доменам, услугам, а также именам
     * закреплённых менеджеров и их цепочек подчинения).
     */
    filteredClients: (state) => {
      const query = (state.search || '').trim().toLowerCase()
      if (!query) {
        return state.clients
      }
      return state.clients.filter(client => {
        // managers может отсутствовать: ответ из кэша предыдущей версии его не содержит
        const managers = Array.isArray(client.managers) ? client.managers : []
        const haystack = [
          client.name || '',
          client.login || '',
          ...(Array.isArray(client.domains) ? client.domains : []),
          ...(Array.isArray(client.services) ? client.services : []),
          ...managers.map(manager => manager.name || ''),
          ...managers.reduce(
            (names, manager) => names.concat(Array.isArray(manager.chain) ? manager.chain : []),
            []
          )
        ].join(' ').toLowerCase()
        return haystack.indexOf(query) !== -1
      })
    }
  }
}
